export default __webpack_public_path__ + "static/media/validate-svg.279fcbc7.svg";